  
$('#tabs-nav li:first-child a').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  $('#tabs-nav li a').click(function(){
    $('#tabs-nav li a').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    var activeTab = $(this).attr('href');
    //  alert(activeTab)
    $('.tab-content').each(function(){
    var tab  = $(this).attr('href') ;
    //alert(tab);
    if(activeTab == tab ){
      $(this).fadeIn();   
    }
    })  
  return false;
}); 

$('#logo_nav li:first-child a').addClass('active');
  $('.logo_content').hide();
  $('.logo_content:first').show();

  $('#logo_nav li a').click(function(){
    $('#logo_nav li a').removeClass('active');
    $(this).addClass('active');
    $('.logo_content').hide();
    var activeTab = $(this).attr('href');
    //  alert(activeTab)
    $('.logo_content').each(function(){
    var tab  = $(this).attr('href') ;
    //alert(tab);
    if(activeTab == tab ){
      $(this).fadeIn();   
       $('.logo_content ul').slick('refresh');  
    }
    })  
  return false;
}); 



$('.logo_image').slick({
  dots: false,
  infinite:true,
  slidesToShow: 6,
  slidesToScroll: 1,
  prevArrow: '<span class="left"><svg width="50" height="14" viewBox="0 0 50 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6151 0L0 6.81818L13.6151 13.6364C13.7568 12.7066 13.4067 11.7718 13.1069 10.841C12.5328 9.57493 11.9339 8.55215 11.0105 7.44035L50 8.4295V5.20686L11.0105 6.197C11.9339 5.08421 12.5328 4.06341 13.1069 2.79533C13.4067 1.86553 13.7568 0.929797 13.6151 0Z" fill="white"/></svg></span>',
  nextArrow: '<span class="right"><svg width="50" height="14" viewBox="0 0 50 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.3849 0L50 6.81818L36.3849 13.6364C36.2432 12.7066 36.5933 11.7718 36.8931 10.841C37.4672 9.57493 38.0661 8.55215 38.9895 7.44035L-3.8147e-06 8.4295V5.20686L38.9895 6.197C38.0661 5.08421 37.4672 4.06341 36.8931 2.79533C36.5933 1.86553 36.2432 0.929797 36.3849 0Z" fill="white"/></svg></span>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});


$('.Slider_banner').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
    dots: false,
    prevArrow: '<span class="itg_left"><svg width="50" height="14" viewBox="0 0 50 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6151 0L0 6.81818L13.6151 13.6364C13.7568 12.7066 13.4067 11.7718 13.1069 10.841C12.5328 9.57493 11.9339 8.55215 11.0105 7.44035L50 8.4295V5.20686L11.0105 6.197C11.9339 5.08421 12.5328 4.06341 13.1069 2.79533C13.4067 1.86553 13.7568 0.929797 13.6151 0Z" fill="white"/></svg></span>',
  nextArrow: '<span class="itg_right"><svg width="50" height="14" viewBox="0 0 50 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.3849 0L50 6.81818L36.3849 13.6364C36.2432 12.7066 36.5933 11.7718 36.8931 10.841C37.4672 9.57493 38.0661 8.55215 38.9895 7.44035L-3.8147e-06 8.4295V5.20686L38.9895 6.197C38.0661 5.08421 37.4672 4.06341 36.8931 2.79533C36.5933 1.86553 36.2432 0.929797 36.3849 0Z" fill="white"/></svg></span>'
});


$(document).ready(function() {
  $(".accordion_set .accordion").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".menu.dropdown-child.content")
        .slideUp(200);
      $(".accordion_set .accordion i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".accordion_set .accordion i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".accordion_set .accordion").removeClass("active");
      $(this).addClass("active");
      $(".menu.dropdown-child.content").slideUp(200);
      $(this)
        .siblings(".menu.dropdown-child.content")
        .slideDown(200);
    }
  });

 $("button.CollectionToolbar__Item").click(function(){
    $(".itg_custom_filter").addClass("active");
  });
   $("button.Drawer__Close").click(function(){
        $('.itg_custom_filter').removeClass('active');
    });

 $(document).on("click",".spr-summary-actions-newreview",function() {
   $(document).find("a.spr-icon").click();
   $(document).find(".spr-form-review-rating").hide();
});
  
  
});

 



